<div
  [ngClass]="containerClasses()"
  [ngStyle]="overlayStyle()"
  [attr.role]="'status'"
  [attr.aria-live]="ariaLive()"
  [attr.aria-label]="resolvedAriaLabel()">
  @if (title() && titlePosition() === 'top') {
    <div [ngClass]="titleClasses()">
      {{ title() }}
    </div>
  }

  @if (title() && titlePosition() === 'left') {
    <div [ngClass]="titleClasses()">
      {{ title() }}
    </div>
  }

  <div class="hx-loader-wrapper">
    @if (!showFallback()) {
      <img
        [src]="logoPath()"
        [alt]="alt()"
        [title]="alt()"
        [ngClass]="loaderClasses()"
        [ngStyle]="{
          width: loaderWidth(),
          height: loaderHeight(),
        }"
        class="hx-loader__image"
        (error)="handleImageError($event)" />
    } @else {
      <div
        [ngClass]="loaderClasses()"
        [ngStyle]="{
          width: loaderWidth(),
          height: loaderHeight(),
        }"
        class="hx-loader__fallback">
        <span class="hx-loader__fallback-text">⏳</span>
      </div>
    }
  </div>

  @if (title() && titlePosition() === 'right') {
    <div [ngClass]="titleClasses()">
      {{ title() }}
    </div>
  }

  @if (title() && titlePosition() === 'bottom') {
    <div [ngClass]="titleClasses()">
      {{ title() }}
    </div>
  }
</div>
